import { iCustomerPaymentMethod } from "@sdk/customer-payment-methods/customer-payment-method-model";
import { CreateEntitySlice } from "../../utils/entity-slice-creator";
import { customerPaymentMethodsDefaultQueryConfig } from "./customer-payment-methods-default-query";

export const {
  slice: CustomerPaymentMethodsSlice,
  reducers: CustomerPaymentMethodsSliceReducer,
  actions: {
    setEntityQueryResults: setCustomerPaymentMethodsQueryResults,
    setEntity: setCustomerPaymentMethod,
    setEntities: setCustomerPaymentMethods,
    patchEntity: patchCustomerPaymentMethod,
    addNewEntity: addNewCustomerPaymentMethod,
    setEntityFetchingStatus: setCustomerPaymentMethodFetchingStatus,
    setEntitiesFetchingStatus: setCustomerPaymentMethodsFetchingStatus,
    setEntityFailedStatus: setCustomerPaymentMethodFailedStatus,
    setEntityQueryError: setCustomerPaymentMethodsQueryError,
    resetQuery: resetCustomerPaymentMethodsQuery,
    setQueryList: setCustomerPaymentMethodQueryList,
  },
} = CreateEntitySlice<iCustomerPaymentMethod>({
  sliceName: "customerPaymentMethods",
  queryAliasResolver: (queryAlias: string) => {
    if (queryAlias === "all") {
      return {
        ...customerPaymentMethodsDefaultQueryConfig,
        alias: "all",
      };
    }
  },
});
